import { useQuery } from '@tanstack/react-query'

import { tenantService } from '@/services/http/tenantService'

export const usePublicTenantConfig = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['tenantPublicConfig'],
    queryFn: () => tenantService.getPublicConfigs(),
  })

  return {
    publicConfig: data ?? null,
    isLoadingPublicConfig: isLoading,
  }
}
